import { patchFolderSnapshotBodyCached } from "@/lib/mail/inboxFolderBus";

export const MAIL_BODY_WARMED_EVENT = "mailBodiesWarmed";

export type MailBodyWarmedDetail = {
  accountId: number;
  folder: string;
  flags: Record<string, boolean>;
};

export function notifyBodiesWarmed(
  accountId: number,
  folder: string,
  flags: Record<string, boolean>
): void {
  const readyUids = Object.entries(flags)
    .filter(([, ready]) => ready === true)
    .map(([key]) => Number(key))
    .filter((uid) => uid > 0);
  if (readyUids.length === 0) return;

  patchFolderSnapshotBodyCached(accountId, folder, readyUids);

  window.dispatchEvent(
    new CustomEvent<MailBodyWarmedDetail>(MAIL_BODY_WARMED_EVENT, {
      detail: { accountId, folder, flags },
    })
  );
}
